import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getJobsListPaged, getTotalJobs, removethisItem } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';



import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';


class Jobs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      exportbtndisabled:false,  
      thisExportBtnText:'Export'
    }

    this.getTotal = this.getTotal.bind(this);
    this.getList = this.getList.bind(this);
  }


    getTotal = () => {

     
      getTotalJobs().then((res) => {

        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    }  

  componentDidMount() {

          var THIS = this;
      $(document).on('click', '.dlte', function () {
        var delete_id = $(this).data("id");
        
        if(confirm("You are sure to delete?")==true){

          let ins = JSON.stringify({
            id: delete_id,
            table:'jobs'
          });

          removethisItem(ins).then((res) => {

            if(res.status==1){
              NotificationManager.success('Removed successfully');
            }else{
              NotificationManager.error('Issue in removing');
            }
            this.getTotal();
            this.getList();

          });

      }


      });
      
      this.getTotal();
      this.getList();

  }


      getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);


      let ins = JSON.stringify({
        perpage:this.state.PER_PAGE,
        offset:newOffset
      });

      getJobsListPaged(ins).then((res) => {

        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          
          this.setState({ list: res.list});


        } else {

              this.setState({loading:!this.state.loading});
              
              this.setState({
                list: [],
              });
        }
      });


    }  
 

    handlePageChange(pageNumber) {

          console.log(`active page is ${pageNumber}`);

          this.setState({activePage: pageNumber});

          //this.getTotal('bw_schools');
          this.getList(pageNumber);


    }   

 
  render() {
        const { list } = this.state;
        const { currentPage, PER_PAGE, totalCount, total, exportbtndisabled } = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Jobs</h4>
                   
                   <div class="float-right"><a href="/wiseconnect/addjob" class="btn btn-primary btn-sm">Add New</a></div>
                
                 <div class="table-responsive pt-3">
                     <table class="table table-bordered table-sm">
                      <thead  class="thead-dark">
                        <tr>
                         
                          <th>S.No</th>
                          <th>Job title</th>
                          <th>Date</th>
                          <th>Posted By</th>
                          <th>Status</th>
                          <th>Action</th>                          
                        </tr>
                      </thead>
                      <tbody>
                      {list.length>0 && list.map((job, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          
                         
                          <td>{job.job_title}</td>

                          <td>{new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(job.created_date)}</td>

                          <td>{job.organisation}</td>

                          <td className={(job.job_status==0)?'inactivecss':'activecss'}>{(job.job_status==0)?'Inactive':'Active'}</td>

                          <td>
                            
                            <a href={"/wiseconnect/editjob/"+job.id} class="btn btn-primary btn-sm" data-id={job.id}>Edit</a>&nbsp;
                            <button class="btn btn-primary btn-sm dlte" data-id={job.id}>Remove</button>
                          </td>
                        
                        </tr>

                      })

                      }

                      {list.length==0 && 

                      <tr><td colSpan="6">No data</td></tr>
                       }
                       
                      </tbody>
                    </table>


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>

                  </div>
                    
 
                </div>
              </div>
            </div>  <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default Jobs;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/jobs.jsx